module.exports = __webpack_public_path__ + "static/media/flexline_logo_no.5f7206e8.png";